import { render } from "./BecomeMember.vue?vue&type=template&id=4b3bb8c1&scoped=true"
import script from "./BecomeMember.vue?vue&type=script&lang=js"
export * from "./BecomeMember.vue?vue&type=script&lang=js"

import "./BecomeMember.vue?vue&type=style&index=0&id=4b3bb8c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3bb8c1"]])

export default __exports__